import React from "react";
import { Button } from "@material-ui/core";
import { AssignmentOutlined } from "@material-ui/icons";
import moment from "moment";
import { Container, Activity } from "./styles";
import { Item } from "../Item";
import { useTranslation } from "react-i18next";
import CurrentActivitySpotlight from "./CurrentActivitySpotlight";
import { useContacts } from "../../../contexts";

export default function CurrentActivity({ customer }) {
  const { setSpotlight } = useContacts();
  const { t } = useTranslation("Customer");
  const last_activity = customer.last_activity;

  function handleClick() {
    setSpotlight(<CurrentActivitySpotlight customer={customer} />);
  }

  return (
    <Item
      leftAction={<AssignmentOutlined />}
      title={`${t("details.activity.title")}`}
    >
      <Container>
        <Activity>
          {last_activity?.date ? (
            <>
              <p>
                {t(`details.activity.${last_activity.activity_type}`)}:{" "}
                {moment(last_activity.date).format("DD/MM/YY")}{" "}
                {t("details.activity.at")}{" "}
                {moment(last_activity.date).format("HH:mm")}
              </p>

              <p>
                <br />
                <b>{last_activity.notes}</b>
              </p>
            </>
          ) : (
            <p> Nenhuma atividade agendada </p>
          )}
        </Activity>

        <Button variant="outlined" color="primary" onClick={handleClick}>
          {t("details.activity.action")}
        </Button>
      </Container>
    </Item>
  );
}
